module.exports = __webpack_public_path__ + "static/media/127.1eb68661.webp";